<template>
    <div class="page-container">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog v-if="documentoSelected" v-model="dialogoDocumento" max-width="800px" persistent>
            <v-card class="pa-4">
                <div class="conteudo-card mx-auto pa-6">
                    <v-row>
                        <v-col cols="6">
                            <p><strong>Nome:</strong> {{ documentoSelected.estudante }}</p>
                            <p><strong>Matrícula:</strong> {{ documentoSelected.matricula }}</p>
                            <p><strong>Turma:</strong> {{ documentoSelected.turma }}</p>
                            <p v-if="documentoSelected.status == 1"><strong>Autor Impressão:</strong> {{
                                documentoSelected.modifiedBy }}</p>
                        </v-col>
                        <v-col cols="6">
                            <p><strong>Documento:</strong> {{ documentoSelected.documento }}</p>
                            <p><strong>Efeito:</strong> {{ documentoSelected.efeito }}</p>
                            <p><strong>Data da solicitação:</strong> {{ documentoSelected.createdAt }}</p>
                            <p v-if="documentoSelected.status == 1"><strong>Data da impressão:</strong> {{
                                documentoSelected.modifiedAt }}</p>
                        </v-col>
                    </v-row>
                </div>

                <div class="checkbox-container" @change="documentoUpdated = true">
                    <!-- Pedido Feito (Sempre desativado) -->
                    <v-btn small fab class="checkbox-btn">
                        <div class="checkbox-content">
                            <input class="form-check-input" type="checkbox" v-model="documentoSelected.pedidoFeito"
                                id="flexCheckChecked" disabled />
                            <label for="flexCheckChecked" class="checkbox-label">Pedido Feito</label>
                        </div>
                    </v-btn>

                    <!-- Em Processamento (Só pode ser ativado se Pedido Feito estiver marcado) -->
                    <v-btn small fab class="checkbox-btn">
                        <div class="checkbox-content">
                            <input class="form-check-input" type="checkbox" id="flexCheckChecked2"
                                v-model="documentoSelected.emProcessamento"
                                :disabled="documentoSelected.status == 1 || !documentoSelected.pedidoFeito || documentoSelected.prontoLevantar == 1" />
                            <label for="flexCheckChecked2" class="checkbox-label">Em Processamento...</label>
                        </div>
                    </v-btn>

                    <!-- Pronto a Levantar (Só pode ser ativado se Em Processamento estiver marcado) -->
                    <v-btn small fab class="checkbox-btn">
                        <div class="checkbox-content">
                            <input class="form-check-input" type="checkbox" id="flexCheckChecked3"
                                v-model="documentoSelected.prontoLevantar"
                                :disabled="documentoSelected.status == 1 || !documentoSelected.emProcessamento" />
                            <label for="flexCheckChecked3" class="checkbox-label">Pronto a levantar</label>
                        </div>
                    </v-btn>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" class="white--text" @click="fecharDialogo()">Fechar</v-btn>
                    <v-btn color="green" @click="notificarEstudante()"
                        :disabled="!documentoSelected.emProcessamento || !documentoSelected.prontoLevantar || documentoSelected.status == 1"
                        class="white--text">Notificar Estudante</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Search Bar -->
        <div class="search-container">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar estudante ou documento" outlined
                dense clearable hide-details class="search-bar"></v-text-field>
        </div>

        <!-- Data Table -->
        <v-data-table :headers="header" :items="documentosAll" :search="search" class="configuracoes-table">
            <!-- Custom Index Column -->
            <template v-slot:item.index="{ item }">
                <span> {{ documentosAll.indexOf(item) + 1 }}</span>
            </template>
            <!-- Status Column -->
            <template v-slot:item.status="{ item }">
                <span>{{ item.status == 1 ? 'Finalizado' : 'Não Finalizado' }}</span>
            </template>

            <!-- Action Menu Column -->
            <template v-slot:item.action="{ item }">
                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                        <v-icon color="green darken-3" v-on="on" size="25" class="mr-2"
                            @click="solicitacaoSelected(item)">mdi-eye</v-icon>
                    </template>
                    <span>Visualizar solicitação</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import axios from '../../../plugins/axios';
import Swal from 'sweetalert2';
const ls = require('local-storage')

export default {
    data() {
        return {
            dialogoDocumento: false,
            isLoading: false,
            showEditar: false,
            showEditarEstatidtica: false,
            search: "",
            instituicoesAll: [],
            header: [
                { text: "#", value: "index" },
                { text: "Estudante", value: "estudante" },
                { text: "Matrícula", value: "matricula" },
                { text: "Turma", value: "turma" },
                { text: "Documento", value: "documento" },
                { text: "Efeito", value: "efeito" },
                { text: "DataSolicitação", value: "createdAt" },
                { text: "Estado", value: "status" },
                { text: "Ação", value: "action", align: "center" }
            ],
            documentosAll: [],
            documentoSelected: null,
            dadosEdicao: null,
            valor: 0,
            documentoUpdated: false
        };
    },

    computed: {
        loggedUserName() {
            return ls.get('nomeUsuario')
        }
    },


    created() {
        this.carregarDocumentos();
    },

    methods: {
        async carregarDocumentos() {
            this.isLoading = true;
            try {
                this.documentosAll = await axios.get('/getDocumentosSolicitados').then((res) => res.data);
                await this.carregarTotalSolicitacoes();
            } catch (error) {
                Swal.fire('Informação', 'Erro ao carregar os documentos solicitados!', 'error');
            } finally {
                this.isLoading = false;
            }
        },

        solicitacaoSelected(solicitacao) {
            this.dialogoDocumento = true;
            this.documentoSelected = solicitacao;
        },

        async fecharDialogo() {
            this.isLoading = true;
            try {
                if (this.documentoUpdated) {
                    let params = {
                        id: this.documentoSelected.id,
                        pedidoFeito: this.documentoSelected.pedidoFeito ? 1 : 0,
                        prontoLevantar: this.documentoSelected.prontoLevantar ? 1 : 0,
                        emProcessamento: this.documentoSelected.emProcessamento ? 1 : 0,
                        usuario: this.loggedUserName
                    }

                    await axios.post('/atualizarSolicitacao', params).then((res) => res.data);
                    await this.carregarDocumentos();
                }

            } catch (error) {
                Swal.fire('Informação', 'Erro fechar dialogo!', 'error');
            } finally {
                this.dialogoDocumento = false;
                this.documentoSelected = null;
                this.isLoading = false;
            }
        },

        async notificarEstudante() {
            this.isLoading = true;
            try {
                let params = {
                    id: this.documentoSelected.id,
                    pedidoFeito: this.documentoSelected.pedidoFeito ? 1 : 0,
                    prontoLevantar: this.documentoSelected.prontoLevantar ? 1 : 0,
                    emProcessamento: this.documentoSelected.emProcessamento ? 1 : 0,
                    usuario: this.loggedUserName,
                    estado: 1,
                }

                this.documentoUpdated = true;
                let result = await axios.post('/noticarEstudante', params).then((res) => res.data);

                if (result.affectedRows >= 1) {
                    Swal.fire('Sucesso', 'Notificação enviada para o estudante!', 'success');
                    this.fecharDialogo()
                } else {
                    Swal.fire('Informação', 'Erro ao noticar o estudante!', 'error');
                }
            } catch (error) {
                Swal.fire('Informação', 'Erro ao processar os dados!', 'error');
            } finally {
                this.isLoading = false;
            }
        },

        async carregarTotalSolicitacoes() {
            this.isLoading = true;
            try {
                let result = await axios.get('/getTotalPendentes').then((res) => res.data);
                this.$store.state.solicitacoesPendentes = result[0].totalPendentes;
            } catch (error) {
                Swal.fire('Informação', 'Erro ao carregar as solicitações pendentes!', 'error');
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #f5f5f5;
    overflow: hidden;
}

.search-container {
    width: 40%;
    margin-bottom: 15px;
}

.search-bar {
    width: 100%;
}

.configuracoes-table {
    width: 95%;
    margin: auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
    color: white;
}

.conteudo-card {
    width: 90%;
    max-width: 720px;
    background: white;
    border-radius: 8px;
    text-align: left;
}

.checkbox-container {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
}

.checkbox-btn {
    display: flex;
    align-items: center;
    padding: 10px;
    min-width: 140px;
    background: transparent !important;
    /* Fundo transparente */
    box-shadow: none;
    /* Remove a sombra */
}

.checkbox-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.form-check-input {
    transform: scale(1.2);
    /* Ajusta o tamanho do checkbox */
    cursor: pointer;
    accent-color: #4b5747;
    /* Cor do checkbox */
    background: transparent;
    /* Fundo do checkbox transparente */
    border: 2px solid #4b5747;
    /* Borda personalizada */
}

.checkbox-label {
    color: #4b5747;
    /* Cor do texto */
    font-size: 14px;
    cursor: pointer;
}
</style>
